import { getConfig } from '@/configs/config-accessor';
import { REQUEST_HEADER_AUTH_KEY } from '@/constants/api.constant';
import { handleGetCollection } from '@/constants/db-collection.constants';
import axios from 'axios';
import ApiService from './ApiService';
import { handleSetApiAuthorizationHeader } from './BaseService';


const getApiPrefix = () => getConfig().newApiPrefix;

export interface IPageConfig {
  _id: string;
  title: string;
  description: string;
  path: string;
  pageType: { label: string; value: string };
  configType: { label: string; value: string };
  configuration: { label: string; value: string };
  collection: { label: string; value: string }[];
  pageContainerType: { label: string; value: string };
  isPublicRoute: boolean;
  isEnabled: boolean;
}

export type GetPageConfig_Params = { pagesId: string[] };
export type GetPageConfig_Headers = { token: string };
export type GetPagesConfig_Response = IResponse<IPageConfig[] | null>;
export const getAllPagesConfig = async () => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<GetPagesConfig_Response, DynamicGet_Body>({
    url: `${newApiPrefix}/dynamicmongodb/get`,
    method: 'post',
    data: {
      collection: handleGetCollection('page-config')
    }
  });
};

export const getAllPagesConfigWithCustomTokenAndPages = async (headers: GetPageConfig_Headers, params: GetPageConfig_Params) => {
  const newApiPrefix = getApiPrefix();
  return axios.post(
    `${newApiPrefix}/dynamicmongodb/get`,
    {
      collection: handleGetCollection('page-config'),
      filter: { _id: { $in: params.pagesId } }
    },
    {
      headers: {
        [REQUEST_HEADER_AUTH_KEY]: handleSetApiAuthorizationHeader(headers.token)
      }
    }
  );
};
